module.exports = __webpack_public_path__ + "img/bo.4a50552e.svg";